import { Icon } from '../../../icons';
import { Tooltip } from '../../../tooltip';

type P = {
  tooltip: string;
};

const DaylightSavingTimeIndicator = ({ tooltip }: P) => (
  <Tooltip title={tooltip}>
    <Icon color="error" icon="information-line" size="extra-extra-small" />
  </Tooltip>
);

export default DaylightSavingTimeIndicator;
